import { useEffect } from "preact/hooks";

const colors = [
  "#5A67D8", // Bluish
  "#B16CEA", // Purple
  "#FF5E69", // Reddish
  "#FF8A56", // Orange
  "#FFA84B", // Peach
];

const delays = [0, 0.3, 0.6, 0.9, 1.2]; // Staggered delays

export default function ThinkingAnimation() {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes bounceScale {
        0% { transform: scale(1); }
        50% { transform: scale(2); }
        100% { transform: scale(1); }
      }
    `;
    document.head.appendChild(style);
  }, []);

  return (
    <div className="flex justify-center items-center w-full mt-1">
      <div className="relative inline-flex w-[100px] h-[18px]">
        {colors.map((color, index) => (
          <div
            key={index}
            className="absolute w-[8px] h-[8px] rounded-full"
            style={{
              backgroundColor: color,
              left: `${index * 22}px`, // Ensures proper spacing
              animation: `bounceScale 2.2s ease-in-out infinite`,
              animationDelay: `${delays[index]}s`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}
